// Math.trunc polyfill
/* eslint-disable */

export const mathTrunc = (() => {
    if (Math.trunc) {
        return Math.trunc
    }
    return function(x) {
        return x === 0 ? x : x < 0 ? Math.ceil(x) : Math.floor(x)
    }
})()
